import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { departments } from 'orm'
import { toProjects } from 'ducks/router'
import { useSearch } from 'hooks'

export const useDepartmentDetails = state => {
  const [search, setSearch] = useSearch('')

  const { id } = state

  const dispatch = useDispatch()

  const department = useSelector(state =>
    departments.getItem()(state, { pk: id }),
  )

  React.useEffect(() => {
    dispatch(departments.fetchStart({ pk: id }))
  }, [dispatch, id])

  const handleRedirectToProjects = React.useCallback(
    (id, tab, query) => dispatch(toProjects(id, tab, query)),
    [dispatch],
  )

  return {
    state: {
      department,
      search,
    },
    handlers: {
      setSearch,
      handleRedirectToProjects,
    },
  }
}
